module.exports = __webpack_public_path__ + "d6e2427c77ddcccb6d7a72d3b7431ffb.svg";